import { axiosDefault } from '@/core/utils';
//////////////////////////////////////////////////////
import { TonWallet } from '@/core/interfaces';

const setTonWallet = async (tonWallet: TonWallet) => {
	const url = `/tg/user/wallet/ton`;
	const response = await axiosDefault.put(url, {
		provider: tonWallet.provider,
		accountUserFriendly: tonWallet.account,
	});

	return {
		currentCoins: response.data.currentCoins,
		currentDiamonds: response.data.currentDiamonds,
		isAwardWinning: response.data.isAwardWinning,
		totalCoinsEarned: response.data.totalCoinsEarned,
		data: response.data.data,
	};
};

export const WalletService = {
	setTonWallet,
};
